import script from "./mark-handled-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./mark-handled-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./mark-handled-dialog.vue?vue&type=style&index=0&id=07b977c8&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b977c8"]])

export default __exports__